import { render, staticRenderFns } from "./Arts.vue?vue&type=template&id=2a347bf4&"
import script from "./Arts.vue?vue&type=script&lang=js&"
export * from "./Arts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports